import { t } from 'i18next'

import { ProjectType } from '@/schema'

import { PROJECT_TYPE_OPTIONS } from './constants'

export const getProjectTypeLabel = (type: ProjectType) => {
  const typeLabel = PROJECT_TYPE_OPTIONS.find(
    (option) => option.value === type
  )?.label
  return typeLabel ? t(typeLabel) : ''
}
